<template>
  <div>
    <template v-if="!$store.state.logged">
      <div class="d-flex justify-end flex-wrap ma-5">
        <v-btn
          color="#4B2A66"
          class="ma-1"
          :x-small="$vuetify.breakpoint.xs"
          outlined
          dark
          :to="{ name: 'landing' }"
          >Conheça o Olhadela
        </v-btn>

        <v-btn
          color="#4B2A66"
          class="ma-1"
          :x-small="$vuetify.breakpoint.xs"
          outlined
          dark
          @click.stop="loginDialog = true"
        >
          Faça seu Login
        </v-btn>
        <v-btn
          color="#4B2A66"
          class="ma-1"
          :x-small="$vuetify.breakpoint.xs"
          outlined
          dark
          :to="{ name: 'register-user' }"
        >
          Cadastre-se agora mesmo
        </v-btn>
      </div>
    </template>
    <template v-if="$store.state.logged">
      <div class="d-flex justify-end flex-wrap ma-5">
        <v-btn
          color="#4B2A66"
          class="ma-1"
          dark
          outlined
          :to="{ name: 'register-shop' }"
        >
          Crie seu negócio
        </v-btn>
      </div>
    </template>
    <v-row class="justify-center mt-16">
      <div class="text-h2 pink--text text--darken-2">
        <img src="/logo.svg" width="300" />
      </div>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="6" md="6">
        <SearchField class="mx-3" />
        <v-row v-if="!$store.state.logged">
          <v-col
            :class="$vuetify.breakpoint.xs ? 'justify-center' : 'justify-end'"
            class="d-flex align-center mt-0"
          >
            <span class="text-subtitle-2 pr-2">Defina sua localização:</span>
            <v-btn color="#4B2A66" icon @click="$refs.getLocation.open()">
              <v-icon>mdi-map-marker</v-icon>
            </v-btn>
            <!-- <div v-cloak>
              <div v-if="location">
                Seus dados de localização são {{ location.coords.latitude }},
                {{ location.coords.longitude }}
                {{ location }}
                https://maps.googleapis.com/maps/api/geocode/json?latlng={{
                  location.coords.latitude
                }}%2C{{ location.coords.longitude }}&language=pt
              </div>
            </div> -->
          </v-col>
        </v-row>
        <v-row class="mt-8 d-flex justify-center">
          <v-col
            v-for="category in categories"
            :key="category.id"
            :cols="3"
            class="py-2 px-0 text-center"
          >
            <v-btn icon large color="black" class="elevation-0">
              <v-avatar size="70" @click="search(category.name)">
                <v-icon> {{ category.icon }} </v-icon>
              </v-avatar>
            </v-btn>
            <v-card-title
              class="text-subtitle-2 d-flex justify-center ma-0 pa-0"
            >
              {{ category.name }}
            </v-card-title>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="loginDialog" class="ma-0 pa-0" max-width="400px">
      <Login @logged="loginDialog = false" />
    </v-dialog>

    <GetLocation ref="getLocation" />
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
import SearchField from "@/components/SearchField.vue";
import GetLocation from "@/components/GetLocation.vue";

export default {
  name: "SearchPage",
  components: {
    Login,
    SearchField,
    GetLocation,
  },
  data: () => ({
    // gettingLocation: false,
    loginDialog: false,
    categories: [],
  }),
  methods: {
    // async getLocation() {
    //   return new Promise((resolve, reject) => {
    //     if (!("geolocation" in navigator)) {
    //       reject(new Error("Geolocation is not available."));
    //     }

    //     navigator.geolocation.getCurrentPosition(
    //       (pos) => {
    //         resolve(pos);
    //       },
    //       (err) => {
    //         reject(err);
    //       }
    //     );
    //   });
    // },
    // async locateMe() {
    //   this.gettingLocation = true;
    //   try {
    //     this.gettingLocation = false;
    //     this.$watchLocation(location).then((coordinates) => {
    //       console.log(coordinates);
    //     });

    //     this.location = await this.getLocation();
    //   } catch (e) {
    //     this.gettingLocation = false;
    //     this.errorStr = e.message;
    //   }
    // },
    search(search) {
      if (search.length > 0)
        this.$router.push({
          path: "/busca/" + search,
          params: {
            query: this.searchQuery,
          },
        });
      if (this.searchQuery) {
        this.searchHistory.unshift({
          title: this.searchQuery,
          completed: "false",
          id: 1,
        });
      }
    },
  },
  mounted() {
    document.title = `Olhadela`;
    this.$axios.get("/categories").then((response) => {
      this.categories = response.data;
    });
  },
};
</script>
